import type { ReactElement } from 'react';

import type {
  ResolverParameters,
  ResolverResult,
} from '../types/resolvers.type';

import { useDevisPrestationsContent } from './hooks/useDevisPrestationsContent.hook';

export const useDevisPrestations = (
  parameters: ResolverParameters,
): ResolverResult<ReactElement> =>
  useDevisPrestationsContent(parameters, 'text');
